import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { paths } from '@mc/paths'
import { Locations } from '@mc/track-event'
import {
  getPageSourceFromPath,
  shouldHideEnterpriseCTAInNav,
  shouldScrollToForm,
} from 'components/Navigation/enterprise/utils'
import { useFlw1235EnterpriseNavCtaOverride } from 'experiments/flw-1235_v2_enterprise_nav_cta'
import { useIsAllAccessEnabled } from '../../../../../experiments/prcng-897_v1_standalone-bundle'
import { getProducts } from '../../mobileMenuProducts'
import { AccordionMenu } from '../AccordionMenu'
import { EnterpriseCallout } from './EnterpriseCallout'

const Search = dynamic(
  () =>
    import(
      /* webpackChunkName: 'mobile-nav-search' */ 'components/Navigation/shared/Mobile/Search'
    ),
  { ssr: false },
)

export const EnterpriseMobileMenu = ({
  newForBusinessPageEnabled = false,
}: {
  newForBusinessPageEnabled?: boolean
}) => {
  const { pathname, query } = useRouter()
  const { isEnabled: isAllAccessEnabled } = useIsAllAccessEnabled()
  const enterpriseCtaCopy = useFlw1235EnterpriseNavCtaOverride()

  const products = getProducts({
    pathname,
    query: query as Record<string, string>,
    newForBusinessPageEnabled,
    onCallLinksEnabled: true,
    allAccessEnabled: isAllAccessEnabled,
    enterpriseCtaCopy,
    Callout: !shouldHideEnterpriseCTAInNav(pathname) && (
      <EnterpriseCallout
        pageSource={getPageSourceFromPath({ pathname, query })}
        location={Locations.NAVIGATION}
        scrollToForm={shouldScrollToForm(pathname)}
        href={
          shouldScrollToForm(pathname)
            ? '#contact-form'
            : paths.enterprisePurchase
        }
      />
    ),
    productType: 'enterprise',
  })

  return (
    <>
      <Search />
      <AccordionMenu
        products={products}
        defaultExpandedProduct='enterprise'
        productSectionClassName='mc-bg-container-tint-medium'
      />
    </>
  )
}
